import { safeJson } from "src/app/helpers/Index";
import { faCloudArrowDown, faPencil, faPeopleGroup, faTrash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { ClubContext } from "src/app/helpers/ClubContext";
import { ResizeImage } from "src/app/helpers/ResizeImage";
import { Col, Nav, Row } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { Team } from "src/app/interfaces/Index";
import { FileService, PlayerService, TeamService } from "src/app/services/Index";
import { SquadImport } from "src/app/components/SquadImport";
import { colours } from "src/app/Styles";
import { environment } from "src/environments/environment";
import "./AdminTeams.css";

type Props = {};
type State = {
	isLoading: boolean;
	filters1: any;
	globalFilter: string;
	masterItems: Team[];
	items: Team[];
	selectedItem: Team;
	selectedItems: Team[];
	showDeleteModal: boolean;
	showDeleteSelectionModal: boolean;
	showItemInfoModal: boolean;
	showPlayers: boolean;
	importTeam: Team;
	showImportModal: boolean;
	submitted: boolean;
	viewMode: string;
};

export class AdminTeams extends React.Component<Props, State> {
	dt: any;	
	toast: any;
	itemName: string = "Team";
	itemNamePlural: string = "Teams";

	constructor(props: Props) {
		super(props);
		this.state = {isLoading: false, filters1: {"global": { value: null, matchMode: FilterMatchMode.CONTAINS }}, globalFilter: "", masterItems: [], selectedItem: new Team(), selectedItems: [], items: [], showDeleteModal: false, showDeleteSelectionModal: false, showItemInfoModal: false, showPlayers:false, importTeam: new Team(), showImportModal: false, submitted: false, viewMode: "tiles"};
	}

	categoryChange(e: any) {
		let selectedItem = {...this.state.selectedItem};
		// selectedItem.type = e.value;
		this.setState({selectedItem});
	}

	componentDidMount() {
		this.getItems();
	}

	deleteItemFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={(data) => this.deleteItemConfirm(data)}></Button>
			</>
		);
	}

	deleteItemsFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteSelectionModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={() => this.deleteSelectedItemConfirm()}></Button>
			</>
		);
	}

	async deleteItemConfirm(rowData: any) {
		const res = await TeamService.deleteSingleById(this.state.selectedItem.id);
		if (!res.ok) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
		} else {
			this.toast.show({closable: false, detail: this.state.selectedItem.teamName + " has been deleted", life: 5000, severity: "warn", summary: "Team deleted!"});
		}
		this.getItems();
		this.setState({showDeleteModal: false});
	}

	deleteSelectedItemConfirm() {}

	itemInfoFooter() {
			return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({selectedItem: new Team(), showItemInfoModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveItem()}></Button>
			</>
			);
	}

	globalFilterChange(e: any) {
		let value = ""
		if (e !== ""){
			value = e.target.value;
			let newData = this.state.masterItems.filter(function(item){
				return item.teamName?.toLowerCase().includes(value.toLowerCase());
			 });
			 this.setState({items:newData});
		} else this.setState({items:this.state.masterItems});
		this.setState({globalFilter:value});    
	}

	async getItems() {
		this.setState({isLoading: true});
		const res = await safeJson(TeamService.getAll());
		if (res && res.error) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
		this.setState({isLoading: false, items: res, masterItems:res});
	}

	inputChange(e: any, name: string) {
		const val = (e.target && e.target.value) || "";
		let selectedItem = new Team({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	inputNumberChange(e: any, name: string) {
		const val = e.value || 0;
		let selectedItem = new Team({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	render() {
		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{paddingTop: "1.5rem"}}>
							<h5 style={{paddingBottom: "1rem", paddingLeft: "1.5rem"}}>{this.itemNamePlural}</h5>
							<Toolbar left={() => this.renderLeftToolbarButtons()} right={() => this.renderRightToolbarButtons()}></Toolbar>
							{this.state.viewMode === "tiles" && this.renderTiles()}
							{this.state.viewMode === "list" &&
							<DataTable loading={this.state.isLoading} onSelectionChange={(e) => this.setState({selectedItems: e.value})} ref={(el) => this.dt = el} scrollable scrollHeight="flex" selection={this.state.selectedItems} style={{height: "calc(100vh - 17.5rem)"}} value={this.state.items}>
								{/* <Column headerStyle={{width: 50}} selectionMode="multiple"></Column> */}
								<Column header="Avatar" body={(rowData: any) => <img alt={rowData.image} className="product-image" src={`${rowData.badgeUrl}`} height="50"/>}></Column>
								<Column field="teamName" header="Team Name" sortable ></Column>
								<Column field="teamNameShort" header="Team Short Name" sortable ></Column>
								<Column style={{width: 75}} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({selectedItem: rowData, showItemInfoModal: true})} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faPencil} style={{color: colours.white}}/>
										</Button>
										<Button onClick={() => this.setState({selectedItem: rowData, showPlayers: true})} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faPeopleGroup} style={{color: colours.white}}/>
										</Button>
										<Button onClick={() => this.setState({importTeam: rowData, showImportModal: true})} style={{backgroundColor: colours.primary, borderColor: colours.primary, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faCloudArrowDown} style={{color: colours.white}}/>
										</Button>
										{Number(rowData.id) !== ClubContext.homeTeamId &&
											<Button onClick={() => this.setState({selectedItem: rowData, showDeleteModal: true})} style={{backgroundColor: colours.error, borderColor: colours.error, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
												<FontAwesomeIcon icon={faTrash} style={{color: colours.white}}/>
											</Button>
										}
									</div>
								)}></Column>
							</DataTable>
							}
							<Dialog className="p-fluid" footer={() => this.itemInfoFooter()} header={this.itemName + " Details"} modal onHide={() => this.setState({ showItemInfoModal: false })} style={{ width: "75%" }} visible={this.state.showItemInfoModal}>
										<Row>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="badgeUrl" style={{ width: "100%" }}>Team Badge</label>
													<img id="badgeUrl" src={this.state.selectedItem.badgeUrl} style={{ height: 90, marginBottom: 10, marginTop: 10 }}></img>
												</div>
										<FileUpload accept="image/*" auto customUpload name="badgeUrl" style={{marginBottom: 10}} uploadHandler={(data) => this.uploadImage(data, "badgeUrl")} mode="basic"></FileUpload>
											</Col>
										</Row>
										<Row>
										<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="teamName">Team Name</label>
													<InputText id="teamName" value={this.state.selectedItem.teamName} onChange={(e) => this.inputChange(e, "teamName")} />
												</div>
											</Col>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="teamNameShort">Team Name Short</label>
													<InputText id="teamNameShort" value={this.state.selectedItem.teamNameShort} onChange={(e) => this.inputChange(e, "teamNameShort")}/>
												</div>
											</Col>
										</Row>
							</Dialog>
							<SquadImport onHide={() => this.setState({ showImportModal: false })} onImported={(done, failed) => { this.toast.show({ closable: false, detail: `${done} player${done === 1 ? "" : "s"} imported${failed ? `, ${failed} failed` : ""}.`, life: 5000, severity: failed ? "warn" : "success", summary: `${this.state.importTeam.teamName} squad` }); this.setState({ showImportModal: false }); }} team={this.state.importTeam} visible={this.state.showImportModal} />
							<Dialog footer={() => this.deleteItemFooter()} header="Confirm" modal onHide={() => this.setState({showDeleteModal: false})} style={{width: 550}} visible={this.state.showDeleteModal}>
								<div className="align-items-center d-flex">
									<i className="pi pi-exclamation-triangle" style={{fontSize: "2rem", marginRight: 12}}/>
									<span>Are you sure you want to delete <b>{this.state.selectedItem.teamName}</b>? The team will disappear from team lists and the away-team dropdown, but past fixtures keep their record.</span>
								</div>
							</Dialog>
						</div>
					</Col>
				</Row>
				<Toast ref={(el) => this.toast = el}></Toast>
				{this.state.showPlayers && (
								<Navigate replace={true} to={`/${environment.build.adminRoute}/team-players/${this.state.selectedItem.id}`} />
				)}
			</>
		);
	}

	renderTiles() {
		const items = Array.isArray(this.state.items) ? this.state.items : [];
		const hero = items.find((x) => Number(x.id) === ClubContext.homeTeamId);
		const rest = items.filter((x) => Number(x.id) !== ClubContext.homeTeamId);
		return (
			<div className="team-tiles-wrapper">
				{hero &&
					<div className="team-hero" onClick={() => this.setState({selectedItem: hero, showPlayers: true})}>
						{hero.badgeUrl
							? <img alt={hero.teamName} className="team-hero-badge" src={hero.badgeUrl}/>
							: <div className="team-hero-placeholder">{(hero.teamNameShort || hero.teamName || "?").substring(0, 3)}</div>
						}
						<div style={{flex: 1}}>
							<div className="team-hero-tag">Home Team</div>
							<div className="team-hero-name">{hero.teamName}</div>
							<div className="team-hero-short">{hero.teamNameShort}</div>
						</div>
						<div className="team-tile-actions">
							<Button onClick={(e) => { e.stopPropagation(); this.setState({selectedItem: hero, showItemInfoModal: true}); }} style={{backgroundColor: "rgba(255, 255, 255, 0.16)", borderColor: "rgba(255, 255, 255, 0.4)", height: 36, justifyContent: "center", padding: 0, width: 36}}>
								<FontAwesomeIcon icon={faPencil} style={{color: colours.white}}/>
							</Button>
							<Button onClick={(e) => { e.stopPropagation(); this.setState({selectedItem: hero, showPlayers: true}); }} style={{backgroundColor: "rgba(255, 255, 255, 0.16)", borderColor: "rgba(255, 255, 255, 0.4)", height: 36, justifyContent: "center", padding: 0, width: 36}}>
								<FontAwesomeIcon icon={faPeopleGroup} style={{color: colours.white}}/>
							</Button>
						</div>
					</div>
				}
				<div className="team-tiles">
					{rest.map((team, i) =>
						<div className="team-tile" key={`team-tile-${i}`} onClick={() => this.setState({selectedItem: team, showPlayers: true})}>
							{team.badgeUrl
								? <img alt={team.teamName} className="team-tile-badge" src={team.badgeUrl}/>
								: <div className="team-tile-placeholder">{(team.teamNameShort || team.teamName || "?").substring(0, 3)}</div>
							}
							<div className="team-tile-name">{team.teamName}</div>
							<div className="team-tile-short">{team.teamNameShort}</div>
							<div className="team-tile-actions">
								<Button onClick={(e) => { e.stopPropagation(); this.setState({selectedItem: team, showItemInfoModal: true}); }} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 32, justifyContent: "center", padding: 0, width: 32}}>
									<FontAwesomeIcon icon={faPencil} style={{color: colours.white}}/>
								</Button>
								<Button onClick={(e) => { e.stopPropagation(); this.setState({selectedItem: team, showPlayers: true}); }} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 32, justifyContent: "center", padding: 0, width: 32}}>
									<FontAwesomeIcon icon={faPeopleGroup} style={{color: colours.white}}/>
								</Button>
								<Button onClick={(e) => { e.stopPropagation(); this.setState({selectedItem: team, showDeleteModal: true}); }} style={{backgroundColor: colours.error, borderColor: colours.error, height: 32, justifyContent: "center", padding: 0, width: 32}}>
									<FontAwesomeIcon icon={faTrash} style={{color: colours.white}}/>
								</Button>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}

	renderLeftToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-plus" label="New" style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, marginRight: 10}} onClick={() => this.setState({selectedItem: new Team(), showItemInfoModal: true})}></Button>
				<Button className={this.state.viewMode === "tiles" ? "" : "p-button-outlined"} icon="pi pi-th-large" label="Tiles" style={this.state.viewMode === "tiles" ? {backgroundColor: colours.primary, borderColor: colours.primary} : {}} onClick={() => this.setState({viewMode: "tiles"})}></Button>
				<Button className={this.state.viewMode === "list" ? "" : "p-button-outlined"} icon="pi pi-list" label="List" style={this.state.viewMode === "list" ? {backgroundColor: colours.primary, borderColor: colours.primary, marginLeft: 6} : {marginLeft: 6}} onClick={() => this.setState({viewMode: "list"})}></Button>
				{/* <Button disabled={!this.state.selectedItems || !this.state.selectedItems.length} icon="pi pi-trash" label="Delete" style={{backgroundColor: colours.graphs.negative, borderColor: colours.graphs.negative, marginRight: 10}} onClick={() => this.setState({showDeleteSelectionModal: true})}></Button> */}
			</>
		);
	}

	renderRightToolbarButtons() {
		return (
			<>
			<div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={()=>{this.globalFilterChange("")}} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilter} onChange={(e)=> {this.globalFilterChange(e)}} placeholder="Keyword Search" />
                </span>
            </div>
				<Button icon="pi pi-upload" label="Export" style={{backgroundColor: colours.buttons.export, borderColor: colours.buttons.export, marginLeft: 10}} onClick={() => this.dt?.exportCSV()}></Button>
			</>
		);
	}

	async saveItem() {
		this.setState({isLoading: true});
		if (this.state.selectedItem.id === -1 || this.state.selectedItem.id === undefined) { // Create new
			const res = await safeJson(TeamService.createSingle(this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
			this.setState({isLoading: false, showItemInfoModal:false});
			this.toast.show({closable: false, detail: this.itemName + " has been created", life: 5000, severity: "success", summary: this.itemName + " created!"});
		} else { // Save existing
			const res = await safeJson(TeamService.updateSingleById(this.state.selectedItem.id,this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
			this.setState({isLoading: false, showItemInfoModal:false});
			this.toast.show({closable: false, detail: this.itemName + " has been saved", life: 5000, severity: "success", summary: this.itemName + " saved!"});
		}
		this.getItems();
	}

	async uploadImage(data: any, property: string) {
		const containerName = "uploads";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", await ResizeImage(data.files[0]));
		uploadData.append("mimeTypeKey", "Images");
		const response = await(await FileService.upload(uploadData)).json();
		let selectedItem = {...this.state.selectedItem};
		// @ts-ignore // Required to be able to change the values
		selectedItem[property] = `${environment.server.storageUrl}/${response[0].location}`;
		await this.setState({selectedItem});
	}
		
}